<template>
  <div class="app-main-inner">
    <div class="app-main-top">
      <h1>Payment List</h1>
      <div class="date-box">
          <el-date-picker
            type="daterange"
            v-model="sreachDate"
            range-separator="To"
            start-placeholder="Start Time"
            end-placeholder="End Time"
            :picker-options="pickerOptionsBefore"
            format="yyyy-MM-dd"
            value-format="yyyy/MM/dd"
            :clearable="false">
          </el-date-picker>          
      </div>
      <div class="select-box margin-left-30">
        <b></b>
        <el-select v-model="tabsValue" placeholder="Please select">
          <el-option
            v-for="item in tabs"
            :key="item.id"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>     
      <div class="search-btn" @click="handleSearch">Search</div> 
    </div>
    <div class="app-main-middle">
       <div class="payment-box">
          <div class="payment-box-innner">
            <div class="table-payment">
              <el-table
                :data="paymentData"
                :highlight-current-row="false"
                style="width: 100%">
                <el-table-column
                  prop="name"
                  label="Name"
                  align="center">
                  <template slot-scope="scope" v-if="paymentData.length>0">
                    <div v-if="scope.row.financeRecord.type===1">
                      Withdraw
                    </div>
                    <div v-else>
                      {{scope.row.name}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="amount"
                  label="Amount"
                  align="center">
                  <template slot-scope="scope" v-if="paymentData.length>0">
                    <div v-if="scope.row.financeRecord.type===1">
                      - {{scope.row.financeRecord.amount}} $
                    </div>
                    <div v-else>
                      + {{scope.row.financeRecord.amount}} $
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="time"
                  label="Time"
                  align="center">
                  <template slot-scope="scope" v-if="paymentData.length>0">
                    {{$utils.formatTime(scope.row.financeRecord.createdAt)}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="status"
                  label="Status"
                  align="center">
                  <template slot-scope="scope" v-if="paymentData.length>0">
                    <div v-if="scope.row.financeRecord.status===0">
                      Waiting for Payment
                    </div>
                    <div v-else-if="scope.row.financeRecord.status===1" class="payment-status-success">
                      Success
                    </div>
                    <div v-else class="payment-status-error" @click="openWhyDialog(scope.row.financeRecord.reason)">
                      Fail(see why?)
                    </div>
                  </template>
                </el-table-column>
              </el-table>   
              <div class="pagination">
                <el-pagination
                  layout="prev, pager, next"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :total="pageSize*totalPages"
                  :page-size="pageSize"
                  :current-page="pageNumber"
                  v-if="totalPages>1"
                  >
                </el-pagination>         
              </div> 
            </div>
          </div>
       </div>
    </div>
    <div class="box dialog-box" v-bind:class="{ fade: isWhyfade}">
      <div class="box-inner">
        <div class="dialog-info">
          <div class="dialog-close-btn" @click="closeWhyDialog"></div>
          <div class="title">Why did it fail</div>
          <div class="message">{{why}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "components/app-header/app-header";
import AppSilder from "components/app-silder/app-silder";
import { ERR_OK } from "api/config";
import { getFinanceRecords } from "api/payment";
export default {
  data() {
    return {
      pickerOptionsBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      paymentData: [],
      isWhyfade: false,
      why: "",
      tabs: [
        {
          value: "",
          label: "All"
        },
        {
          value: 0,
          label: "Income"
        },
        {
          value: 1,
          label: "Withdraw"
        }
      ],
      tabsValue: "",
      sreachDate: [],
      pageNumber: 1,
      pageSize: 10,
      totalPages: ""
    };
  },
  components: {
    AppHeader,
    AppSilder
  },
  created() {
    this.defaultDate();
    this._getFinanceRecords();
  },
  methods: {
    formatDate(strTime) {
      let date = new Date(strTime);
      return (
        date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate()
      );
    },
    defaultDate() {
      let start = new Date();
      let week = start.getTime() - 3600 * 1000 * 24 * 7;
      let end = new Date(week);
      start = this.formatDate(start);
      end = this.formatDate(end);
      this.sreachDate = [end, start];
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNumber = val;
      this._getFinanceRecords();
    },
    _getFinanceRecords() {
      let financeRecordsParam = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        startTime: this.sreachDate[0],
        endTime: this.sreachDate[1],
        type: this.tabsValue
      };
      getFinanceRecords(financeRecordsParam)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.paymentData = response.data.data.content;
              this.totalPages = response.data.data.totalPages;
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    handleSearch() {
      this.pageNumber = 1;
      this._getFinanceRecords();
    },
    openWhyDialog(why) {
      this.isWhyfade = true;
      this.why = why;
      document.body.setAttribute("class", "dialogfade");
    },
    closeWhyDialog() {
      this.isWhyfade = false;
      document.body.removeAttribute("class", "dialogfade");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/variables.scss";
@import "~styles/mixin.scss";
.app-main-inner {
  background: transparent;
  border: 0px;
  .app-main-top {
    height: auto;
    line-height: initial;
    background-color: #fff;
    border-radius: 5px;
    border: 1px solid #ededed;
    padding: 0px 20px 10px;
    h1 {
      font-size: 20px;
      margin: 0px 10px;
      line-height: 54px;
    }
    .date-box {
      display: inline-block;
      height: 36px;
      float: left;
    }
    .select-box {
      width: 200px;
    }
    .search-btn {
      display: inline-block;
      width: 95px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      background: rgba(255, 164, 56, 0.5);
      border: 1px solid #ffa438;
      border-radius: 20px;
      color: #fff;
      position: relative;
      top: -9px;
      margin-left: 30px;
      cursor: pointer;
    }
  }
  .app-main-middle {
    padding: 20px 0px;
    .payment-box {
      .payment-box-top {
        height: 32px;
        line-height: 32px;
        margin-bottom: 20px;
        h1 {
          display: inline-block;
          float: left;
          font-size: 20px;
          color: #333333;
          margin: 0px 30px 0px 0px;
        }
        .payment-btn {
          display: inline-block;
          background: rgba(255, 164, 56, 0.5);
          border: 1px solid #ffa438;
          border-radius: 20px;
          color: #fff;
          width: 110px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          font-size: 14px;
        }
      }
    }
  }
}
.pagination {
  background: #fff;
  text-align: center;
  .el-pagination {
    display: inline-block;
  }
}
.payment-status-success {
  color: #ffa438;
}
.payment-status-error {
  cursor: pointer;
  color: #ff6868;
}
</style>




// WEBPACK FOOTER //
// src/views/payment/paymentList.vue